import { render, staticRenderFns } from "./earning.vue?vue&type=template&id=a56b7b4a&"
import script from "./earning.vue?vue&type=script&lang=js&"
export * from "./earning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports